import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconSend: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" color="#333333" {...props}>
        <path d="M2.5 20V14L14.5 12L2.5 10V4L21.5 12L2.5 20Z" fill="currentColor" />
    </Icon>
);
